<script>
    import store from "../../store";
    import Errors from "../../helpers/Errors";

    import PackagePanel from "../onboarding/PackagePanel";
    import InviteBody from "../onboarding/invite/InviteBody";
    import InviteModal from "../onboarding/invite/InviteModal";
    import InviteMainBillPayer from "../onboarding/invite/InviteMainBillPayer.vue";

    export default {
        name: "InviteHousematesForm",

        props: {
            'household': {
                type: Object,
                required: true
            },
            'housemates': {
                type: Array,
                required: true
            },
            'errorMessages': {
                required: false
            },
            'old': {
                type: String,
                required: false
            }
        },

        components: {
            PackagePanel,
            InviteBody,
            InviteModal,
            InviteMainBillPayer,
        },

        data() {
            return {
                housemates_confirmed: false, // Partner On-boarding
                submitted: false,
                lead_filled: false,
                errors: new Errors(JSON.parse(this.errorMessages)),
            }
        },

        mounted() {
            store.commit('invite/setUsers', {
                'users': this.housemates, // Users already in db
                'amount': this.household.bill_payers // Total amount of users in household
            });

        },

        methods: {
            housemateError(key, value) {
                let keys = key.split('.'); // e.g. housemate.1.first_name
                // Slight hack to print correct housemate number
                // If we cant get the housemate number, just print the message
                return Number.isInteger(keys) ? 'Housemate ' + (+keys[1] + 1) + ': ' + value : '' + value;
            },

            async submit() {
                if (this.submitted) {
                    return; // Prevent multiple submissions
                }

                // Validate Inputs
                if(!await this.verifyLead()){
                    this.$data.lead_filled = false;
                    return;
                }

                // Disable submit button to prevent
                this.submitted = true;

                // Submit the form
                document.getElementById('invite_form').submit();
            },

            async verifyLead() {

                // Get inputs
                let first_name = document.getElementsByName('leadHousemate[first_name]')[0]['value'];
                let last_name = document.getElementsByName('leadHousemate[last_name]')[0]['value'];
                let phone_number = {
                    'country_code': document.getElementsByName('leadHousemate[telephone_number][country_code]')[0]['value'],
                    'national_number': document.getElementsByName('leadHousemate[telephone_number][national_number]')[0]['value']
                }

                // Refresh error messages
                this.$data.errors.wipe();

                if (!first_name) {
                    this.$data.errors.create(
                        "first_name",
                        "First name is required."
                    );
                }

                if (!last_name) {
                    this.$data.errors.create(
                        "last_name",
                        "Last name is required.");
                }

                if (!phone_number.national_number) {
                    this.$data.errors.create(
                        "phone_number",
                        "Phone number is required."
                    );
                }

                let alpha_regex =
                    /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;

                if (!first_name.match(alpha_regex)) {
                    this.$data.errors.create(
                        "first_name",
                        "First name must be letters."
                    );
                }

                if (!last_name.match(alpha_regex)) {
                    this.$data.errors.create(
                        "last_name",
                        "Last name must be letters."
                    );
                }

                if (phone_number.national_number) {
                    try {
                        const response = await axios.get(
                            '/onboarding/validate-number',
                            {params: {number: phone_number.country_code + phone_number.national_number},}
                        );
                        document.getElementsByName('leadHousemate[phone_number]')[0]['value'] = response.data;
                    } catch (e) {
                        this.$data.errors.create('phone_number', 'Phone number is not valid.');
                    }

                }

                return _.size(this.$data.errors.all()) === 0;
            },
        },

        computed: {
            users() {
                return this.$store.getters['invite/getUsers'];
            },

            isCompleted() {
                return this.$store.getters['invite/getAllUsersCompleted'];
            },

            housemateConfirmed() {
                // If we only have one bill payer, the checkbox won't appear
                if (_.size(this.users) === 1) {
                    this.housemates_confirmed = true;
                }
                return (this.housemates_confirmed && this.$store.getters['invite/getAllUsersCompleted']);
            },

            getLeadHousemate() {
                return this.$store.getters['invite/getBillPayer'];
            }
        },

        watch: {
            getLeadHousemate(newValue) {
                this.$data.lead_filled = !!(newValue['first_name'] && newValue['last_name'] &&
                    newValue['phone_number']['national_number']);
            },
        },

    }
</script>
